import { OktaAuth } from "@okta/okta-auth-js";

const redirectUri = `${window.location.origin}/login/callback`;
const clientId = process.env.REACT_APP_OKTA_CLIENT_ID;

const oktaConfig = {
    oktaAuth: {
        clientId,
        issuer: `https://${process.env.REACT_APP_OKTA_DOMAIN}/oauth2/default`,
        redirectUri,
        scopes: ["openid", "profile", "email", "offline_access"],
        pkce: true,
        // responseType: ['token', 'id_token', 'refresh_token'],
        tokenManager: {
            autoRenew: true,
            // autoRemove: false,
            // storage: 'sessionStorage',
            // expireEarlySeconds: 2800,
            expireEarlySeconds: 1200,
        },
    },
    domain: process.env.REACT_APP_OKTA_DOMAIN,
};

const oktaClient = new OktaAuth(oktaConfig.oktaAuth);

export { oktaClient, oktaConfig };
